import { track } from "jiffy-analytics";

const $getCsrfMetaTag = () => document.querySelector('meta[name="csrf-token"]');
const $getCsrfInputs = () => document.querySelectorAll('input[name="authenticity_token"]');
const getCurrentCsrfToken = () => $getCsrfMetaTag()?.getAttribute("content") || "";

const setCsrfMetaTag = token => {
  $getCsrfMetaTag()?.setAttribute("content", token);
};

const setCsrfInputs = token => {
  $getCsrfInputs().forEach($input => $input.setAttribute("value", token));
};

const notifyError = (message, error, source) => {
  const params = {
    error: error?.message,
    status: error?.status,
    url: window.location.href,
    source
  };
  const eventName = message.toLowerCase().replaceAll(" ", "_");

  window.Honeybadger?.notify(message, params);
  track(eventName, params);
};

const updateCsrfTokens = (token, source) => {
  try {
    setCsrfMetaTag(token);
    setCsrfInputs(token);
    return true;
  } catch (error) {
    notifyError("CSRF token update failed", error, source);
    return false;
  }
};

const refreshCsrfToken = async source => {
  try {
    const response = await fetch("/api/refresh_token", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": getCurrentCsrfToken()
      }
    });

    if (!response.ok) {
      throw new Error("Failed to refresh CSRF token");
    }

    const data = await response.json();
    return updateCsrfTokens(data.csrf_token, source);
  } catch (error) {
    notifyError("CSRF token refresh failed", error, source);
    return false;
  }
};

export { refreshCsrfToken, getCurrentCsrfToken };
